var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3478_295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1222 20.6336V18.6685C21.1222 16.4979 19.3626 14.7383 17.192 14.7383H9.33157C7.16098 14.7383 5.40137 16.4979 5.40137 18.6685V20.6336",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2617 10.808C15.4323 10.808 17.192 9.04844 17.192 6.87784C17.192 4.70725 15.4323 2.94763 13.2617 2.94763C11.0911 2.94763 9.33154 4.70725 9.33154 6.87784C9.33154 9.04844 11.0911 10.808 13.2617 10.808Z",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0175 17.6336V15.6686C25.0162 13.8774 23.8041 12.3138 22.0698 11.8661",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1396 2.07544C21.8786 2.5207 23.095 4.0877 23.095 5.88282C23.095 7.67796 21.8786 9.24495 20.1396 9.69022",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.0001 17.5058V15.5408C2.00142 13.7496 3.2135 12.186 4.94775 11.7383",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87598 1.94751C5.13701 2.39277 3.92066 3.95977 3.92066 5.75489C3.92066 7.55003 5.13701 9.11702 6.87598 9.56229",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478_295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5812,
    height: 23.5812,
    fill: "white",
    transform: "translate(4.41895)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.97d05c21.svg";
export { ForwardRef as ReactComponent };